import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';
import Panel from 'react-bootstrap/lib/Panel';

import {
  faRocket,
  faRuler,
  faList,
  faChartLine,
  faDollarSign,
} from '@fortawesome/free-solid-svg-icons';

import Link from '../../../../../components/Link';
import PageLayout from '../../../../../components/PageLayout';

import ShadowerLink from '../../../../../components/ShadowerLink';

import Navbar from '../../../../../components/Handbook/Navbar';

import s from '../../HandbookPage.scss';

class WelcomeToShadowerPage extends React.Component {
  render() {
    return (
      <PageLayout className={s.page}>
        <div className={s.container}>
          <div className={s.navbar}>
            <div className={s.title}>Shadowing Handbook</div>
            <Navbar
              navbarIcon={faRocket}
              navbarSection="Getting Started"
              navbarSubsection={
                <div>
                  <Link
                    className={cx(s.link, s.active)}
                    to="/handbook/getting-started/welcome-to-shadower"
                  >
                    Welcome to Shadower
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/how-shadower-works"
                  >
                    How Shadower Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/working-with-businesses"
                  >
                    Working with Businesses
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/shadowing-guidelines"
                  >
                    Shadowing Guidelines
                  </Link>
                </div>
              }
              overrideDefault
            />

            <Navbar
              navbarIcon={faRuler}
              navbarSection="Planning a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/choosing-a-topic"
                  >
                    Choosing a Topic
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/interactivity-level"
                  >
                    Interactivity Level
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/session-type"
                  >
                    Session Type
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/providing-resources"
                  >
                    Providing Resources
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faList}
              navbarSection="Managing a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/expectations"
                  >
                    Expectations
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/session-flow"
                  >
                    Session Flow
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/maximizing-your-time"
                  >
                    Maximizing Your Time
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faChartLine}
              navbarSection="Promoting Your Profile"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-the-platform-works"
                  >
                    How the Platform Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/optimizing-your-profile"
                  >
                    Optimizing Your Profile
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/marketing-yourself"
                  >
                    Marketing Yourself
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-to-build-a-following"
                  >
                    How to Build a Following
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faDollarSign}
              navbarSection="Earning Revenue"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/how-payment-works"
                  >
                    How Payment Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/connecting-with-the-community"
                  >
                    Connecting with the Community
                  </Link>
                </div>
              }
            />

            <Link className={s.newProfileLink} to="/user/profiles/new">
              Create a shadowing profile
            </Link>
          </div>

          <div className={s.explanation}>
            <Panel>
              <Panel.Heading>
                <div>Getting Started</div>
              </Panel.Heading>
              <Panel.Body>
                <div className={s.handbookTitle}>A guide for experts</div>
                <div className={s.subsectionTitle}>Welcome to Shadower</div>

                <img
                  alt="Shadowing"
                  src="/assets/images/handbook/shadowing@1280x600.jpg"
                />

                <p>
                  Welcome to Shadower! This guide will help you begin earning
                  revenue by allowing others to shadow you.
                </p>

                <div className={s.contentContainer}>
                  <div>
                    <strong>What is Shadower?</strong>
                  </div>
                  <p>
                    Shadower is an online platform that helps amateurs find
                    experts to shadow in real life.
                  </p>

                  <p>
                    Our experts are everyday artists, creators, producers,
                    entrepreneurs and professionals looking to share their
                    knowledge with others in a meaningful and impactful way by
                    building and maintaining relationships with others in their
                    local communities.
                  </p>

                  <p>
                    Our mission is to reimagine how education works in an age
                    when experience and connections matter most.
                  </p>

                  <p>
                    Interested in joining the shadowing community? Learn how the
                    platform works and get started creating your first session
                    today!
                  </p>
                </div>

                <ShadowerLink
                  className={s.nextLink}
                  to="/handbook/getting-started/how-shadower-works"
                >
                  Next {'>'}
                </ShadowerLink>
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </PageLayout>
    );
  }
}

export default withStyles(s)(WelcomeToShadowerPage);
